<template>
  <div class="base_space pb-8">
    <base-alert type="warn" text="sonico_profiles_moved" />
    <FormError :errors="errors" />
    <div class="flex space-x-8">
      <dl class="w-full">
        <div class="bg-white px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 items-center">
          <dt class="text-lg leading-5 font-medium text-secondary-dark">
            {{ $t(`mygwf.components.Form.email`) }} : <span class="text-red-default">*</span>
          </dt>
          <dd class="mt-1 leading-5 sm:mt-0 sm:col-span-2">
            <base-input v-model="user.email" type="email" />
          </dd>
        </div>
        <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 items-center">
          <dt class="text-lg leading-5 font-medium text-secondary-dark">
            {{ $t(`mygwf.components.Form.role`) }}
          </dt>
          <dd class="mt-1 leading-5 sm:mt-0 sm:col-span-2 space-x-4 flex flex-col">
            <base-alert type="info" size="sm" text="gwf_staff_user" />
            <div class="flex flex-col justify-center my-6 space-y-5">
              <label>
                <input :value="1" v-model="role" type="radio" />
                <span class="ml-2">GWF Staff</span>
              </label>
              <label>
                <input :value="2" v-model="role" type="radio" />
                <span class="ml-2">Company Admin</span>
              </label>
            </div>
          </dd>
        </div>
        <div v-if="!isGwf" class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 items-center">
          <dt class="text-lg leading-5 font-medium text-secondary-dark">
            {{ $t(`mygwf.components.Form.company`) }}
          </dt>
          <dd class="leading-5 sm:col-span-2 space-x-4 flex items-center justify-between">
            <SingleSelect
              :options="fields.company.options"
              class="w-full shadow p-4 text-sm"
              v-model="user.company"
            />
          </dd>
        </div>
        <template v-if="showSonicoProfiles">
          <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 items-center">
            <dt class="text-lg leading-5 font-medium text-secondary-dark">
              {{ $t(`mygwf.components.Form.sonico_profile`) }}
              <span
                class="px-2 inline-flex text-xs leading-2 font-semibold rounded text-white bg-blue-light"
                >optional</span
              >
            </dt>
            <dd class="mt-1 leading-5 sm:mt-0">
              <base-select
                v-model="user.sonico_profile"
                :options="profileOptions"
                :optionType="{id: 'id', label: 'name'}"
                allowClear
              />
            </dd>
          </div>
        </template>
      </dl>
    </div>
    <div class="flex space-x-3 py-5 px-4 my-1 justify-end border-t">
      <span class="self-center mr-auto"
        ><span class="text-red-default">*</span> {{ requiredFieldText }}</span
      >
      <base-button @click="$router.back()" action="close" context="secondary">
        <base-icon icon="close" />
      </base-button>
      <base-button @click="submit()" action="save" :loading="loading" :disabled="isFormDisabled">
        <base-icon icon="success" />
      </base-button>
    </div>
  </div>
</template>

<script>
import {BaseAlert, BaseButton, BaseIcon, BaseInput, BaseSelect} from '@/components/base'
import SingleSelect from '@/components/shared/SingleSelect.vue'
import {required, email} from 'vuelidate/lib/validators'

export default {
  data() {
    return {
      user: {},
      errors: {},
      role: 1,
      loading: false,
    }
  },
  methods: {
    async submit() {
      this.loading = true
      const user = {...this.user}
      if (this.isGwf) {
        user.is_gwf_staff = true
      }
      if (this.isCompanyAdmin) {
        user.is_admin = true
      }
      try {
        if (this.isGwf && !this.isGwfStaffEmail) {
          throw {detail: {email: ['member_of_GWF']}}
        }
        await this.$store.dispatch(`users/create`, user)
        this.$store.dispatch('app/notification', {type: 'success', group: 'app', text: `created`})
        this.user = {}
        this.errors = {}
      } catch (errors) {
        this.errors = errors
      } finally {
        this.loading = false
      }
    },
  },
  computed: {
    fields() {
      return this.$store.getters['users/createFields']
    },
    showSonicoProfiles() {
      return (
        this.isGwf ||
        this.$store.getters['companies/getServices'](this.user.company).find(
          service => service.id === 2
        )
      )
    },
    isGwf() {
      return this.role === 1
    },
    isGwfStaffEmail() {
      return this.user.email?.split('@')[1].includes('gwf')
    },
    isFormDisabled() {
      return this.$v.user.$invalid || (this.isGwf ? !this.isGwfStaffEmail : false)
    },
    isCompanyAdmin() {
      return this.role === 2
    },
    profileOptions() {
      const profileOptions = []
      this.$store.getters['users/sonicoProfiles'].forEach(p =>
        profileOptions.push({id: p.id, name: `${p.name} (UID: ${p.id})`})
      )
      return profileOptions
    },
    requiredFieldText() {
      return this.$t('mygwf.components.Form.requiredField')
    },
  },
  validations: {
    user: {
      email: {
        required,
        email,
      },
    },
  },
  components: {
    BaseAlert,
    BaseButton,
    BaseIcon,
    BaseInput,
    BaseSelect,
    SingleSelect,
    FormError: () => import('@/components/shared/FormError.vue'),
  },
}
</script>
